import { CurrentTestState, ScoringState } from '@app/storage'
import { Box, styled } from '@mui/material'
import { FC } from 'react'
import { useSnapshot } from 'valtio'
import PassageHeader from './components/PassageHeader'

interface InfoControlLayoutProps {
  children?: JSX.Element | JSX.Element[]
}

const InfoControlLayout: FC<InfoControlLayoutProps> = ({ children }) => {
  const { passages } = CurrentTestState
  const { isQuestionPreviewMode } = useSnapshot(ScoringState)

  return (
    <Container aria-label='Question additional information block'>
      {passages.length && !isQuestionPreviewMode ? <PassageHeader /> : null}
      <InfoControlLayoutWrapper>{children}</InfoControlLayoutWrapper>
    </Container>
  )
}

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  maxWidth: '683px',
  flex: '1 1 50%',
  overflow: 'auto',
  flexDirection: 'column',
  borderRadius: theme.shape.borderRadius * 1.5,
  boxShadow: theme.shadows[2],
  backgroundColor: theme.palette.common.white,
  // a11y: grow to content + stop nested vertical scroll once the frame is released (SC 1.4.10)
  [theme.breakpoints.down('tablet')]: {
    overflow: 'visible',
  },
  [theme.breakpoints.down('mobile')]: {
    flex: '1 1 auto',
  },
}))

const InfoControlLayoutWrapper = styled(Box)(({ theme }) => ({
  flex: '1 1 auto',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  // a11y: release inner vertical scroll at high zoom; wide content still scrolls locally (SC 1.4.10)
  [theme.breakpoints.down('tablet')]: {
    overflowX: 'auto',
    overflowY: 'visible',
  },
}))

export default InfoControlLayout
